import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import YoutubeIcon from '../../foundations/Icon/icons/social/Youtube';

import {
  ColIconStyled,
  ColLinkStyled,
  ColPictureStyled,
  DocumentLinkStyled,
  ImageContainerStyled,
  LinkStyled,
  RowStyled,
  TypographyStyled,
} from './styles';

export const DocumentLinkComponent = ({
  children,
  className,
  iconObject: RenderIcon,
  imageUrl,
  imageVariant,
  isOutgoingLink,
  linkAriaLabel,
  linkId,
  linkUrl,
}) => {
  const documentLinkText = useRef();
  const addHoverState = () => {
    documentLinkText.current.classList.add('hover-state-active');
  };
  const removeHoverState = () => {
    documentLinkText.current.classList.remove('hover-state-active');
  };

  return (
    <DocumentLinkStyled className={className}>
      <LinkStyled
        id={linkId}
        linkUrl={linkUrl}
        ariaLabel={linkAriaLabel}
        onMouseOver={addHoverState}
        onMouseOut={removeHoverState}
        onFocus={addHoverState}
        onBlur={removeHoverState}
        isOutgoingLink={isOutgoingLink}
      >
        <RowStyled>
          {imageVariant === 'icon' && (
            <ColIconStyled
              xsmall={4}
              large={3}>
              <RenderIcon />
            </ColIconStyled>
          )}
          {imageVariant === 'image' && (
            <ColPictureStyled xsmall={4}>
              <ImageContainerStyled
                backgroundImage={imageUrl}>
              </ImageContainerStyled>
            </ColPictureStyled>
          )}
          <ColLinkStyled xsmall={8}>
            <TypographyStyled ref={documentLinkText}>
              {children}
            </TypographyStyled>
          </ColLinkStyled>
        </RowStyled>
      </LinkStyled>
    </DocumentLinkStyled>
  );
};

DocumentLinkComponent.propTypes = {
  /** required description text */
  children: PropTypes.node.isRequired,
  /** optional additional className */
  className: PropTypes.string,
  /** select between the imageVariant types */
  imageVariant: PropTypes.oneOf(['icon', 'image']),
  /** coincides with imageVariant='icon', iconObject must be supplied */
  iconObject: PropTypes.any,
  /** coincides with imageVariant='image', imageUrl must be supplied */
  imageUrl: PropTypes.any,
  /** optional isOutgoingLink boolean */
  isOutgoingLink: PropTypes.bool,
  /** optional aria-label of link */
  linkAriaLabel: PropTypes.any,
  /** required id of the link */
  linkId: PropTypes.string.isRequired,
  /** required URL of link */
  linkUrl: PropTypes.string.isRequired,
};

DocumentLinkComponent.defaultProps = {
  iconObject: YoutubeIcon,
  imageVariant: 'icon',
};

export default DocumentLinkComponent;
